export async function FETCH_USER({ commit }, { userId }) {
  const user = await this.$alfredService.adminGetUser(userId);
  commit("SET_USER", user);
}
